import(/* webpackMode: "eager" */ "/home/eduardo/projetos/agro-monitor-web/src/app/layout.tsx")